<hr [ngStyle]="captionStyles()">